function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var getHandlerDetailStyle = function getHandlerDetailStyle(prefixCls, token) {
  return _defineProperty(_defineProperty(_defineProperty({}, ".".concat(prefixCls), _defineProperty(_defineProperty(_defineProperty({
    padding: '16px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px'
  }, ".handlerTotal", {
    fontSize: '16px',
    fontWeight: '500',
    lineHeight: '22px',
    color: '#0D1121'
  }), ".emptyWrapper", {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    margin: '0 auto'
  }), ".phoneWrapper", _defineProperty({
    cursor: 'pointer'
  }, ".phoneIcon", {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '4px'
  }))), ".".concat(prefixCls, " .ant-table"), {
    borderLeft: '1px solid #E1E1E7',
    borderRight: '1px solid #E1E1E7',
    borderTop: '1px solid #E1E1E7'
  }), ".".concat(prefixCls, " .ant-table td, .").concat(prefixCls, ".table-container .ant-table th"), {
    border: 'none'
  });
};